import React from "react";
import { Select } from "antd";

import debounce from "lodash/debounce";
import { QuoteList } from "../../../../models/quote";

const Option = Select.Option;

export class QuoteSelector extends React.Component {
  state = {
    data: [],
    value: [],
    fetching: false,
  };
  fetchQuote = (value = '') => {
    this.setState({ data: [], fetching: true });
    const requestData = { 'search': value, type: this.props.type };
    QuoteList(requestData)
      .then(body => {
        const data = body.data.results.filter(quote => !quote.status)
          .map(quote => ({
            text: <div><p><span>Quote Number:</span> {quote.quote_number}</p><p>
              <span>Generator:</span> {quote.generator.company_name}</p></div>,
            value: quote.id
          }));
        this.setState({ data, fetching: false });
      });
  };

  handleChange = (value) => {
    this.setState({
      value,
      data: [],
      fetching: false
    });
    this.props.onChange(value);
  };

  constructor(props) {
    super(props);
    this.fetchQuote = debounce(this.fetchQuote, 800);
  }


  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)

  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const { data } = this.state;
    return (
      <div className="pos-relative">
        <Select showSearch style={{ width: "100%" }} placeholder="Select Quote" filterOption={false}
          onSearch={this.fetchQuote} onChange={this.handleChange} onFocus={this.fetchQuote}>
          {data.map(d => (<Option className="opt-style" key={d.value}>{d.text}</Option>))}
        </Select>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/popups/QuoteSelector.jsx